import { Button, Card, Col, Form, Input, Row, Select, Table, Tabs } from 'antd'
import { BaleService } from 'libs/shared-services/raw-material-procurement/src/lib/bale-service'
import React, { useEffect, useRef, useState } from 'react'
import * as XLSX from 'xlsx-js-style'
import { saveAs } from 'file-saver'
import { ColumnProps } from 'antd/lib/table'
import Highlighter from 'react-highlight-words'
import { DownloadOutlined, SearchOutlined } from '@ant-design/icons'
import { BaleReportReq } from '@gtpl/shared-models/raw-material-procurement'

const { Option } = Select
const { TabPane } = Tabs

const BaleReport = () => {

const baleService=new BaleService()

const [activeTab,setActiveTab]=useState('bale')

const [baleData,setBaleData]=useState<any[]>([])
const [baleVariant,setBaleVariant]=useState<any[]>([])
const [baleQuality,setBaleQuality]=useState<any[]>([])
const [baleNo,setBaleNo]=useState<any[]>([])

const [inwardData,setInwardData]=useState<any[]>([])
const [inwardVariant,setInwardVariant]=useState<any[]>([])
const [inwardQuality,setInwardQuality]=useState<any[]>([])
const [vendor,setVendor]=useState<any[]>([])
const [inwardNo,setInwardNo]=useState<any[]>([])


const [searchText,setSearchText]=useState('')
const [searchedColumn,setSearchedColumn]=useState('')
const searchInput=useRef<any>()

const [baleForm]=Form.useForm()
const [inwardForm]=Form.useForm()

useEffect(()=>{
loadBaleMaster()
},[])

const loadBaleMaster=()=>{
getBaleReport()
getBaleNoForBaleReport()
getBaleVariantForBaleReport()
getBaleQualityForBaleReport()
}

const loadInwardMaster=()=>{
getInwardDetails()
getInwardQuality()
getInwardVariant()
getInwardVendor()
getInwardNoForBaleReport()
}

const onTabChange=(key:string)=>{
setActiveTab(key)
if(key==='inward'){
loadInwardMaster()
}
}

const getBaleReport=()=>{
const req=new BaleReportReq()
req.baleNo=baleForm.getFieldValue('baleNo')
req.baleVariantId=baleForm.getFieldValue('baleVariant')
req.baleQuality=baleForm.getFieldValue('baleQuality')
baleService.getBaleReport(req).then(res=>{
if(res.status){
setBaleData(res.data)
}else{
setBaleData([])
}
})
}

const getBaleNoForBaleReport=()=>{
baleService.getBaleNoForBaleReport().then(res=>{
if(res.status){
setBaleNo(res.data)
}else{
setBaleNo([])
}
})
}

const getBaleVariantForBaleReport=()=>{
baleService.getBaleVariantForBaleReport().then(res=>{
if(res.status){
setBaleVariant(res.data)
}else{
setBaleVariant([])
}
})
}

const getBaleQualityForBaleReport=()=>{
baleService.getBaleQualityForBaleReport().then(res=>{
if(res.status){
setBaleQuality(res.data)
}else{
setBaleQuality([])
}
})
}

const getInwardDetails=()=>{
const req=new BaleReportReq()
req.inwardVariantId=inwardForm.getFieldValue('inwardVariant')
req.inwardQuality=inwardForm.getFieldValue('inwardQuality')
req.inwardVendor=inwardForm.getFieldValue('vendor')
req.inwardNo=inwardForm.getFieldValue('inwardNo')
baleService.getinwardDetailsInBaleReport(req).then(res=>{
if(res.status){
setInwardData(res.data)
}else{
setInwardData([])
}
})
}

const getInwardVariant=()=>{
baleService.getInwardVariantForBaleReport().then(res=>{
if(res.status){
setInwardVariant(res.data)
}else{
setInwardVariant([])
}
})
}

const getInwardQuality=()=>{
baleService.getinwardQualityForBaleReport().then(res=>{
if(res.status){
setInwardQuality(res.data)
}else{
setInwardQuality([])
}
})
}

const getInwardVendor=()=>{
baleService.getInwardVendorForBaleReport().then(res=>{
if(res.status){
setVendor(res.data)
}else{
setVendor([])
}
})
}

const getInwardNoForBaleReport=()=>{
baleService.getInwardNoForBaleReport().then(res=>{
if(res.status){
setInwardNo(res.data)
}else{
setInwardNo([])
}
})
}

const handleSearch=(selectedKeys:any,confirm:any,dataIndex:any)=>{
confirm()
setSearchText(selectedKeys[0])
setSearchedColumn(dataIndex)
}

const handleReset=(clearFilters:any)=>{
clearFilters()
setSearchText('')
}

const getColumnSearchProps=(dataIndex:any)=>({
filterDropdown:({setSelectedKeys,selectedKeys,confirm,clearFilters}:any)=>(
<div style={{padding:8}}>
<Input
ref={searchInput}
placeholder={`Search ${dataIndex}`}
value={selectedKeys[0]}
onChange={e=>setSelectedKeys(e.target.value?[e.target.value]:[])}
onPressEnter={()=>handleSearch(selectedKeys,confirm,dataIndex)}
style={{width:188,marginBottom:8,display:'block'}}
/>
<Button type='primary' size='small' style={{width:90,marginRight:8}} onClick={()=>handleSearch(selectedKeys,confirm,dataIndex)} icon={<SearchOutlined/>}>Search</Button>
<Button size='small' style={{width:90}} onClick={()=>handleReset(clearFilters)}>Reset</Button>
</div>
),
filterIcon:(filtered:any)=><SearchOutlined style={{color:filtered?'#1890ff':undefined}}/>,
onFilter:(value:any,record:any)=>record[dataIndex]?record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()):false,
render:(text:any)=>searchedColumn===dataIndex?<Highlighter highlightStyle={{backgroundColor:'#ffc069',padding:0}} searchWords={[searchText]} autoEscape textToHighlight={text?text.toString():''}/>:text
})

const onResetBale=()=>{
baleForm.resetFields()
getBaleReport()
}

const onResetInward=()=>{
inwardForm.resetFields()
getInwardDetails()
}

    const renderUniqueItems = (record:any,field:string) => {
    const values = [
        ...new Set(
            record.items
                ?.map((item:any)=>item[field])
                .filter(Boolean)
        )
    ];

    return (
        <>
            {values.map((value:any,index:number)=>(
                <React.Fragment key={index}>{value}{index !== values.length-1 &&
                        <hr style={{marginTop:0, marginBottom:0}}/>} 
                </React.Fragment>
            ))}
        </>
    )

}
const Columns: ColumnProps<any>[]  =[
        {
        title:'S.No',
        width:80,
        align:'center',
        render:(_:any,record:any,index:number)=>{return index+1;}
        },

        {
            title:'Inward No',
            ...getColumnSearchProps('inwardNo'),
            sorter:(a:any,b:any)=>{
                const aa=[...new Set(a.items?.map((i:any)=>i.inwardNo))].join(',').toLowerCase();
                const bb=[...new Set(b.items?.map((i:any)=>i.inwardNo))] .join(',') .toLowerCase();
                return aa.localeCompare(bb);
            },
            onFilter:(value:any,record:any)=>{
                return [...new Set(record.items?.map((i:any)=>i.inwardNo))].join(',').toLowerCase().includes(value.toLowerCase());
            },
            render:(_,record)=>renderUniqueItems(record,'inwardNo')
        },
        
        {
        title:'Vendor',
        ...getColumnSearchProps('vendor'),
        sorter:(a,b)=>{const aa=[...new Set(a.items.map(i=>i.vendor))].join(',').toLowerCase();
        const bb=[...new Set(b.items.map(i=>i.vendor))].join(',').toLowerCase();
        return aa.localeCompare(bb);
        },
        onFilter:(value,record)=>{
        return [...new Set(record.items.map(i=>i.vendor))].join(',').toLowerCase().includes(String(value).toLowerCase())
        },
        render:(_,record)=>renderUniqueItems(record,'vendor')
        },

        {
        title:'Inward Variant',
        ...getColumnSearchProps('inwardVariant'),
        sorter:(a,b)=>{
        const aa=[...new Set(a.items.map(i=>i.inwardVariant))].join(',');
        const bb=[...new Set(b.items.map(i=>i.inwardVariant))].join(',');
        return aa.localeCompare(bb);
        },
        onFilter:(value,record)=>{
        return [...new Set(record.items.map(i=>i.inwardVariant))].join(',').toLowerCase().includes(String(value).toLowerCase())
        },
        render:(_,record)=>renderUniqueItems(record,'inwardVariant')
        },

        {
        title:'Inward Quality',
        ...getColumnSearchProps('inwardQuality'),
        sorter:(a,b)=>{
        const aa=[...new Set(a.items.map(i=>i.inwardQuality))].join(',');
        const bb=[...new Set(b.items.map(i=>i.inwardQuality))].join(',');
        return aa.localeCompare(bb);
        },
        onFilter:(value,record)=>{
        return [...new Set(record.items.map(i=>i.inwardQuality))].join(',').toLowerCase().includes(String(value).toLowerCase())
        },
        render:(_,record)=>renderUniqueItems(record,'inwardQuality')
        },

        {
            title:"Inward Quantity",
            dataIndex:'inwardQuantity',
            render: (text: any, record: any) => {
        return record?.items?.map((data, index) => {
          let tag = index !== record?.items.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
          return <>{data?.inwardQuantity} {tag}</>
        });
        },
        },

        {
        title:'Inward Price/Kg',
        sorter:(a,b)=>{
            const aa=Math.max(...a.items.map(i=>Number(i.inwardPricePerKg||0)));
            const bb=Math.max(...b.items.map(i=>Number(i.inwardPricePerKg||0)));
        return aa-bb;
        },
        render:(_,record)=>
        renderUniqueItems(record,'inwardPricePerKg')
        },

        {
            title:"Inward Amount",
            dataIndex:'inwardAmount',
            render: (text: any, record: any) => {
        return record?.items?.map((data, index) => {
          let tag = index !== record?.items.length -1  ? <hr style={{ marginTop: '0rem', marginBottom: '0rem' }}></hr> : <></>
          return <>{Number((data?.inwardQuantity)*(data?.inwardPricePerKg))} {tag}</>
        });
        },
        },

        {
            title:'Bale No',
            dataIndex:'baleNo',
            ...getColumnSearchProps('baleNo'),
            sorter: (a, b) => a.baleNo.localeCompare(b.baleNo),
            sortDirections: ['descend', 'ascend'],
        },

        {
            title:'Bale Type',
            dataIndex:'baleType',
            ...getColumnSearchProps('baleType'),
            sorter: (a, b) => a.baleType.localeCompare(b.baleType),
            sortDirections: ['descend', 'ascend'],
        },

        {
            title:"Bale Variant",
            dataIndex:'baleVariant',
            ...getColumnSearchProps('baleVariant'),
            sorter: (a, b) => a.baleVariant.localeCompare(b.baleVariant),
            sortDirections: ['descend', 'ascend'],
        },

        {
            title:'Bale Quality',
            dataIndex:'baleQuality',
            ...getColumnSearchProps('baleQuality'),
            sorter: (a, b) => a.baleQuality.localeCompare(b.baleQuality),
            sortDirections: ['descend', 'ascend'],
            render:(text:any,record:any)=>{
                return (
                    record.baleQuality?record.baleQuality:'NULL'
                )
            }
        },

        {
            title:"Bale Quantity",
            dataIndex:'baleQuantity',
            sorter:(a,b)=>Number(a.baleQuantity)-Number(b.baleQuantity)
        },

{
title:"Remaining Quantity",
render:(_,record)=>{
return record.baleType==="Export"
?Number(record.baleQuantity)
:Number(record.baleQuantity)-Number(record.workOrderQty);
},
sorter:(a,b)=>{
const aa=a.baleType==="Export"
?Number(a.baleQuantity)
:Number(a.baleQuantity)-Number(a.workOrderQty);

const bb=b.baleType==="Export"
?Number(b.baleQuantity)
:Number(b.baleQuantity)-Number(b.workOrderQty);

return aa-bb;
}
},

{
title:'Total Amount',
render:(_,record)=>{

const remainingQty=record.baleType==="Export"
?Number(record.baleQuantity)
:Number(record.baleQuantity)-Number(record.workOrderQty);

return remainingQty*Number(record.balePrice);

},
sorter:(a,b)=>{

const aa=(a.baleType==="Export"
?Number(a.baleQuantity)
:Number(a.baleQuantity)-Number(a.workOrderQty))*Number(a.balePrice);

const bb=(b.baleType==="Export"
?Number(b.baleQuantity)
:Number(b.baleQuantity)-Number(b.workOrderQty))*Number(b.balePrice);

return aa-bb;

}
},
    ]

const baleHeaders=[
'S.NO',
'Inward No',
'Vendor',
'Inward Variant',
'Inward Quality',
'Inward Quantity',
'Inward Price/Kg',
'Inward Amount',
'Bale No',
'Bale Type',
'Bale Variant',
'Bale Quality',
'Bale Quantity',
'Remaining Quantity',
'Total Amount'
]

    const flattenBaleData=(data:any[])=>{

    let rows:any[]=[];
    let serialNo=1;

    data.forEach((record:any)=>{

const remainingQty=
record.baleType==="Export"
?Number(record.baleQuantity)
:Number(record.baleQuantity)-Number(record.workOrderQty);

        const totalAmount=remainingQty*Number(record.balePrice);

        const inwardNos=[...new Set(record.items.map((x:any)=>x.inwardNo).filter(Boolean))];
        const vendors=[...new Set(record.items.map((x:any)=>x.vendor).filter(Boolean))];
        const variants=[...new Set(record.items.map((x:any)=>x.inwardVariant).filter(Boolean))];
        const qualities=[...new Set(record.items.map((x:any)=>x.inwardQuality).filter(Boolean))];
        const prices=[...new Set(record.items.map((x:any)=>x.inwardPricePerKg).filter(Boolean))];

        const maxRows=Math.max(
            inwardNos.length,
            vendors.length,
            variants.length,
            qualities.length,
            prices.length,
            record.items.length
        );

        for(let i=0;i<maxRows;i++){
            const item=record.items[i];
            rows.push({
                serialNo:i===0?serialNo:'',
                inwardNo:inwardNos[i]||'',
                vendor:vendors[i]||'',
                inwardVariant:variants[i]||'',
                inwardQuality:qualities[i]||'',
                inwardPricePerKg:prices[i]||'',
                inwardQuantity:item?.inwardQuantity||'',
                inwardAmount:item?Number(item.inwardQuantity||0)*Number(item.inwardPricePerKg||0):'',
                baleNo:i===0?record.baleNo:'',
                baleType:i===0?record.baleType:'',
                baleVariant:i===0?record.baleVariant:'',
                baleQuality:i===0?(record.baleQuality||'NULL'):'',
                baleQuantity:i===0?record.baleQuantity:'',
                remainingQuantity:i===0?remainingQty:'',
                totalAmount:i===0?totalAmount:''
            });
        }
        serialNo++;
    });

    return rows;
}

// exportBaleExcel

const exportBaleExcel = () => {
    const exportData = flattenBaleData(baleData);
    const excelData = exportData.map((item:any)=>({
        'S.NO':item.serialNo,
        'Inward No':item.inwardNo,
        'Vendor':item.vendor,
        'Inward Variant':item.inwardVariant,
        'Inward Quality':item.inwardQuality,
        'Inward Quantity':item.inwardQuantity,
        'Inward Price/Kg':item.inwardPricePerKg,
        'Inward Amount':item.inwardAmount,
        'Bale No':item.baleNo,
        'Bale Type':item.baleType,
        'Bale Variant':item.baleVariant,
        'Bale Quality':item.baleQuality,
        'Bale Quantity':item.baleQuantity,
        'Remaining Quantity':item.remainingQuantity,
        'Total Amount':item.totalAmount
    }));

    const totals = {
  inwardQty: 0,
  inwardAmount: 0,
  baleQty: 0,
  remainingQty: 0,
  totalAmount: 0
};

exportData.forEach((r:any) => {

  totals.inwardQty += Number(r.inwardQuantity || 0);
  totals.inwardAmount += Number(r.inwardAmount || 0);
  totals.baleQty += Number(r.baleQuantity || 0);
  totals.remainingQty += Number(r.remainingQuantity || 0);
  totals.totalAmount += Number(r.totalAmount || 0);

});

excelData.push({

'S.NO':'',

'Inward No':'',

'Vendor':'',

'Inward Variant':'',

'Inward Quality':'Grand Total',

'Inward Quantity':totals.inwardQty,

'Inward Price/Kg':'',

'Inward Amount':totals.inwardAmount,

'Bale No':'',

'Bale Type':'',

'Bale Variant':'',

'Bale Quality':'',

'Bale Quantity':totals.baleQty,

'Remaining Quantity':totals.remainingQty,

'Total Amount':totals.totalAmount

});

    const worksheet = XLSX.utils.json_to_sheet( excelData, {header:baleHeaders} );
    const range = XLSX.utils.decode_range( worksheet['!ref']!);

    for(let R=range.s.r;R<=range.e.r;R++){
        for(let C=range.s.c;C<=range.e.c;C++){
            const cellAddress = XLSX.utils.encode_cell({r:R,c:C});

            if(!worksheet[cellAddress])
                continue;

            worksheet[cellAddress].s={

                border:{
                    top:{style:'thin'},
                    bottom:{style:'thin'},
                    left:{style:'thin'},
                    right:{style:'thin'},
                },

                alignment:{
                    vertical:'center',
                    horizontal:'center',
                    wrapText:true
                }
            }
        }
    }

    baleHeaders.forEach((_,i)=>{
        const cell = XLSX.utils.encode_cell({ r:0, c:i});
        if(worksheet[cell]){
            worksheet[cell].s={
                font:{
                    bold:true,
                    color:{rgb:'FFFFFF'}
                },

                fill:{
                    fgColor:{rgb:'4F81BD'  }
                },

                border:{
                    top:{style:'thin'},
                    bottom:{style:'thin'},
                    left:{style:'thin'},
                    right:{style:'thin'}
                },

                alignment:{
                    horizontal:'center',
                    vertical:'center'
                }
            }
        }
    })

worksheet['!cols']=baleHeaders.map(h=>({wch:Math.max(h.length,...excelData.map((r:any)=>String(r[h]||'').length))+5}))

let mergeRanges:any[]=[];
let rowIndex=1;

baleData.forEach((record:any)=>{

    const start=rowIndex;
    const end=rowIndex+record.items.length-1;
    const inwardNos=[...new Set(record.items.map((x:any)=>x.inwardNo).filter(Boolean))];
    const vendors=[...new Set(record.items.map((x:any)=>x.vendor).filter(Boolean))];
    const variants=[...new Set(record.items.map((x:any)=>x.inwardVariant).filter(Boolean))];
    const qualities=[...new Set(record.items.map((x:any)=>x.inwardQuality).filter(Boolean))];
    const prices=[...new Set(record.items.map((x:any)=>x.inwardPricePerKg).filter(Boolean))];

    if(record.items.length>1){
        const mergeColumns=[
            'S.NO',
            'Bale No',
            'Bale Type',
            'Bale Variant',
            'Bale Quality',
            'Bale Quantity',
            'Remaining Quantity',
            'Total Amount'
        ];

        mergeColumns.forEach(col=>{
            mergeRanges.push({
                s:{
                    r:start,
                    c:baleHeaders.indexOf(col)
                },

                e:{
                    r:end,
                    c:baleHeaders.indexOf(col)
                }
            });
        });
        if(inwardNos.length===1){
            mergeRanges.push({
                s:{
                    r:start,
                    c:baleHeaders.indexOf('Inward No')
                },
                e:{
                    r:end,
                    c:baleHeaders.indexOf('Inward No')
                }
            });
        }

        if(vendors.length===1){
            mergeRanges.push({
                s:{
                    r:start,
                    c:baleHeaders.indexOf('Vendor')
                },
                e:{
                    r:end,
                    c:baleHeaders.indexOf('Vendor')
                }
            });
        }

        if(variants.length===1){
            mergeRanges.push({
                s:{
                    r:start,
                    c:baleHeaders.indexOf('Inward Variant')
                },
                e:{
                    r:end,
                    c:baleHeaders.indexOf('Inward Variant')
                }
            });
        }

        if(qualities.length===1){
            mergeRanges.push({
                s:{
                    r:start,
                    c:baleHeaders.indexOf('Inward Quality')
                },
                e:{
                    r:end,
                    c:baleHeaders.indexOf('Inward Quality')
                }
            });
        }

        if(prices.length===1){
            mergeRanges.push({
                s:{
                    r:start,
                    c:baleHeaders.indexOf('Inward Price/Kg')
                },
                e:{
                    r:end,
                    c:baleHeaders.indexOf('Inward Price/Kg')
                }
            });
        }
    }

    rowIndex=end+1;
});

worksheet['!merges']=mergeRanges;
worksheet['!merges']=mergeRanges;
const workbook=XLSX.utils.book_new();
XLSX.utils.book_append_sheet(workbook,worksheet,'Bale Report');
const excelBuffer = XLSX.write(workbook,{bookType:'xlsx',type:'array',cellStyles:true});
saveAs(new Blob([excelBuffer],{type:'application/octet-stream'}),'Bale-Report.xlsx');
}

const renderMergedItems=(record:any,field:string)=>{

const values=[...new Set(record.items?.map((item:any)=>item[field]).filter(Boolean))];

if(values.length===1){
return values[0];
}

return(
<>
{record.items.map((item:any,index:number)=>(
<React.Fragment key={index}>
{item[field]}
{index!==record.items.length-1&&<hr style={{marginTop:0,marginBottom:0}}/>}
</React.Fragment>
))}
</>
);

}

const InwardColumns: ColumnProps<any>[]=[
{
title:'S.No',
width:80,
align:'center',
render:(_,record,index)=>{
return index+1;
}
},
{
title:'Inward No',
dataIndex:'inwardCode',
...getColumnSearchProps('inwardCode'),
sorter:(a,b)=>a.inwardCode.localeCompare(b.inwardCode),
sortDirections:['descend','ascend']

},
{
title:'Inward Type',
dataIndex:'inwardType',
...getColumnSearchProps('inwardType'),
sorter:(a,b)=>a.inwardType.localeCompare(b.inwardType),
sortDirections:['descend','ascend']
},
{
title:'Vendor',
...getColumnSearchProps('vendor'),
sorter:(a,b)=>{
const aa=[...new Set(a.items.map(i=>i.vendor))].join(',').toLowerCase();
const bb=[...new Set(b.items.map(i=>i.vendor))].join(',').toLowerCase();
return aa.localeCompare(bb);
},
onFilter:(value,record)=>{
return [...new Set(record.items.map(i=>i.vendor))]
.join(',')
.toLowerCase()
.includes(String(value).toLowerCase())
},
render:(_,record)=>renderMergedItems(record,'vendor')
},
{
title:'Inward Variant',
...getColumnSearchProps('inwardVariant'),
sorter:(a,b)=>{
const aa=[...new Set(a.items.map(i=>i.inwardVariant))].join(',');
const bb=[...new Set(b.items.map(i=>i.inwardVariant))].join(',');
return aa.localeCompare(bb);
},
onFilter:(value,record)=>{
return [...new Set(record.items.map(i=>i.inwardVariant))]
.join(',')
.toLowerCase()
.includes(String(value).toLowerCase())
},
render:(_,record)=>renderMergedItems(record,'inwardVariant')
},
{
title:'Quality',
...getColumnSearchProps('quality'),
sorter:(a,b)=>{
const aa=[...new Set(a.items.map(i=>i.quality))].join(',');
const bb=[...new Set(b.items.map(i=>i.quality))].join(',');
return aa.localeCompare(bb);
},
onFilter:(value,record)=>{
return [...new Set(record.items.map(i=>i.quality))]
.join(',')
.toLowerCase()
.includes(String(value).toLowerCase())
},
render:(_,record)=>renderMergedItems(record,'quality')
},
{
title:'Inward Quantity',
dataIndex:'inwardQty',
sorter:(a,b)=>Number(a.inwardQty)-Number(b.inwardQty),
render:(_,record)=>{
return record.items?.map((item,index)=>(
<>
{item.inwardQty}
{index!==record.items.length-1 && <hr style={{marginTop:0, marginBottom:0}}/>}
</>
))
}
},
{
title:'Inward Price',
dataIndex:'inwardPrice',
sorter:(a,b)=>Number(a.inwardPrice)-Number(b.inwardPrice),
render:(_,record)=>{
return record.items?.map((item,index)=>(
<>
{item.inwardPrice}
{index!==record.items.length-1 && <hr style={{marginTop:0, marginBottom:0}}/>}
</>
))
}
},
{
title:'Total Amount',
dataIndex:'totalAmt',
sorter:(a,b)=>Number(a.totalAmt)-Number(b.totalAmt),
render:(_,record)=>{
return record.items?.map((item,index)=>(
<>
{item.totalAmt}
{index!==record.items.length-1 && <hr style={{marginTop:0, marginBottom:0}}/>}
</>
))
}
},
{
title:'Remaining Quantity',
dataIndex:'remainingQty',
sorter:(a,b)=>Number(a.remainingQty)-Number(b.remainingQty),
render:(_,record)=>{
return record.items?.map((item,index)=>(
<>
{item.remainingQty}
{index!==record.items.length-1 && <hr style={{marginTop:0, marginBottom:0}}/>}
</>
))
}
},
{
title:'Remaining Amount',
dataIndex:'remainingAmt',
sorter:(a,b)=>Number(a.remainingAmt)-Number(b.remainingAmt),
render:(_,record)=>{
return record.items?.map((item,index)=>(
<>
{item.remainingAmt}
{index!==record.items.length-1 && <hr style={{marginTop:0, marginBottom:0}}/>}
</>
))
}
}
]

const inwardHeaders=[
'S.No',
'Inward No',
'Inward Type',
'Vendor',
'Inward Variant',
'Quality',
'Inward Quantity',
'Inward Price',
'Total Amount',
'Bale Quantity',
'Remaining Quantity',
'Remaining Amount'
]

const flattenInwardData=(data:any[])=>{

let rows:any[]=[];
let serialNo=1;

data.forEach((record:any)=>{

const maxRows=record.items.length;

for(let i=0;i<maxRows;i++){

const item=record.items[i];

rows.push({

serialNo:i===0?serialNo:'',

inwardCode:i===0?record.inwardCode:'',

inwardType:i===0?record.inwardType:'',

vendor:item.vendor,

inwardVariant:item.inwardVariant,

quality:item.quality,

inwardQty:item.inwardQty,

inwardPrice:item.inwardPrice,

totalAmt:item.totalAmt,

baleQty:item.baleQty,

remainingQty:item.remainingQty,

remainingAmt:item.remainingAmt

});

}

serialNo++;

});

return rows;

}

const exportInwardExcel=()=>{

const exportData=flattenInwardData(inwardData);

const excelData=exportData.map((item:any)=>({

'S.No':item.serialNo,

'Inward No':item.inwardCode,

'Inward Type':item.inwardType,

'Vendor':item.vendor,

'Inward Variant':item.inwardVariant,

'Quality':item.quality,

'Inward Quantity':item.inwardQty,

'Inward Price':item.inwardPrice,

'Total Amount':item.totalAmt,

'Bale Quantity':item.baleQty,

'Remaining Quantity':item.remainingQty,

'Remaining Amount':item.remainingAmt

}));

const totals = {
  inwardQty: 0,
  totalAmt: 0,
  baleQty: 0,
  remainingQty: 0,
  remainingAmt: 0
};

exportData.forEach((r: any) => {
  totals.inwardQty += Number(r.inwardQty || 0);
  totals.totalAmt += Number(r.totalAmt || 0);
  totals.baleQty += Number(r.baleQty || 0);
  totals.remainingQty += Number(r.remainingQty || 0);
  totals.remainingAmt += Number(r.remainingAmt || 0);
});

excelData.push({
  'S.No': '',
  'Inward No': '',
  'Inward Type': '',
  'Vendor': '',
  'Inward Variant': '',
  'Quality': 'Grand Total',
  'Inward Quantity': totals.inwardQty,
  'Inward Price': '',
  'Total Amount': totals.totalAmt,
  'Bale Quantity': totals.baleQty,
  'Remaining Quantity': totals.remainingQty,
  'Remaining Amount': totals.remainingAmt
});

const worksheet=XLSX.utils.json_to_sheet(excelData,{header:inwardHeaders});

const range=XLSX.utils.decode_range(worksheet['!ref']!);

for(let R=range.s.r;R<=range.e.r;R++){

for(let C=range.s.c;C<=range.e.c;C++){

const cell=XLSX.utils.encode_cell({r:R,c:C});

if(!worksheet[cell]) continue;

worksheet[cell].s={

border:{
top:{style:'thin'},
bottom:{style:'thin'},
left:{style:'thin'},
right:{style:'thin'}
},

alignment:{
horizontal:'center',
vertical:'center',
wrapText:true
}

};

}

}

inwardHeaders.forEach((_,i)=>{

const cell=XLSX.utils.encode_cell({r:0,c:i});

if(worksheet[cell]){

worksheet[cell].s={

font:{
bold:true,
color:{rgb:'FFFFFF'}
},

fill:{
fgColor:{rgb:'4F81BD'}
},

border:{
top:{style:'thin'},
bottom:{style:'thin'},
left:{style:'thin'},
right:{style:'thin'}
},

alignment:{
horizontal:'center',
vertical:'center'
}

};

}

});

worksheet['!cols']=inwardHeaders.map(h=>({

wch:Math.max(

h.length,

...excelData.map((r:any)=>String(r[h]||'').length)

)+5

}));

let mergeRanges:any[]=[];

let rowIndex=1;

inwardData.forEach((record:any)=>{

const start=rowIndex;

const end=rowIndex+record.items.length-1;

if(record.items.length>1){
const vendors=[...new Set(record.items.map((x:any)=>x.vendor).filter(Boolean))];
const variants=[...new Set(record.items.map((x:any)=>x.inwardVariant).filter(Boolean))];
const qualities=[...new Set(record.items.map((x:any)=>x.quality).filter(Boolean))];

const mergeColumns=[
'S.No',
'Inward No',
'Inward Type'
];

mergeColumns.forEach(col=>{
mergeRanges.push({
s:{r:start,c:inwardHeaders.indexOf(col)},
e:{r:end,c:inwardHeaders.indexOf(col)}
});
});

if(vendors.length===1){
mergeRanges.push({
s:{r:start,c:inwardHeaders.indexOf('Vendor')},
e:{r:end,c:inwardHeaders.indexOf('Vendor')}
});
}

if(variants.length===1){
mergeRanges.push({
s:{r:start,c:inwardHeaders.indexOf('Inward Variant')},
e:{r:end,c:inwardHeaders.indexOf('Inward Variant')}
});
}

if(qualities.length===1){
mergeRanges.push({
s:{r:start,c:inwardHeaders.indexOf('Quality')},
e:{r:end,c:inwardHeaders.indexOf('Quality')}
});
}


}

rowIndex=end+1;

});

worksheet['!merges']=mergeRanges;

const workbook=XLSX.utils.book_new();

XLSX.utils.book_append_sheet(workbook,worksheet,'Inward Details');

const excelBuffer=XLSX.write(workbook,{

bookType:'xlsx',

type:'array',

cellStyles:true

});

saveAs(

new Blob([excelBuffer],{type:'application/octet-stream'}),

'Inward-Details.xlsx'

);

}

const exportExcel=()=>{
if(activeTab==='bale'){
exportBaleExcel()
}else{
exportInwardExcel()
}
}

return (
<div>
<Card
title={<span style={{color:'white'}}>RM Inward Report</span>}
style={{textAlign:'center'}}
headStyle={{backgroundColor:'#69c0ff',border:0}}
extra={<Button icon={<DownloadOutlined/>} onClick={exportExcel}>Get Excel</Button>}
>

<Tabs defaultActiveKey='bale' activeKey={activeTab} onChange={onTabChange}>

<TabPane tab='Bale Details' key='bale'>

<Form form={baleForm} layout='vertical' onFinish={getBaleReport}>

<Row gutter={16}>

<Col span={6}>
<Form.Item label='Bale No' name='baleNo'>
<Select placeholder='Select Bale No' showSearch allowClear optionFilterProp='children'>
{baleNo.map((item:any)=><Option key={item.baleNo} value={item.baleNo}>{item.baleNo}</Option>)}
</Select>
</Form.Item>
</Col>

<Col span={6}>
<Form.Item label='Bale Variant' name='baleVariant'>
<Select placeholder='Select Bale Variant' showSearch allowClear optionFilterProp='children'>
{baleVariant.map((item:any)=><Option key={item.variantId} value={item.variantId}>{item.name}</Option>)}
</Select>
</Form.Item>
</Col>

<Col span={6}>
<Form.Item label='Bale Quality' name='baleQuality'>
<Select placeholder='Select Bale Quality' showSearch allowClear optionFilterProp='children'>
{baleQuality.map((item:any)=><Option key={item.quality} value={item.quality}>{item.quality}</Option>)}
</Select>
</Form.Item>
</Col>

<Col style={{display:'flex',alignItems:'center',marginTop:30}}>
<Button type='primary' htmlType='submit'>Submit</Button>
</Col>

<Col style={{display:'flex',alignItems:'center',marginTop:30}}>
<Button danger onClick={onResetBale}>Reset</Button>
</Col>

</Row>

</Form>

<Table
columns={Columns}
dataSource={baleData}
rowKey='id'
pagination={{pageSize:10}}
scroll={{x:'max-content'}}
summary={(pageData) => {

  const inwardQty = pageData.reduce(
    (sum, r) =>
      sum +
      (r.items || []).reduce(
        (s, i) => s + Number(i.inwardQuantity || 0),
        0
      ),
    0
  );

  const inwardAmount = pageData.reduce(
    (sum, r) =>
      sum +
      (r.items || []).reduce(
        (s, i) => s + Number(i.inwardQuantity || 0) * Number(i.inwardPricePerKg || 0),
        0
      ),
    0
  );

  const baleQty = pageData.reduce(
    (sum, r) => sum + Number(r.baleQuantity || 0),
    0
  );

  const remainingQty = pageData.reduce(
    (sum, r) =>
      sum +
      (r.baleType === "Export"
        ? Number(r.baleQuantity)
        : Number(r.baleQuantity) - Number(r.workOrderQty)),
    0
  );

  const totalAmount = pageData.reduce(
    (sum, r) => {
      const qty =
        r.baleType === "Export"
          ? Number(r.baleQuantity)
          : Number(r.baleQuantity) - Number(r.workOrderQty);

      return sum + qty * Number(r.balePrice || 0);
    },
    0
  );

  return (
    <Table.Summary.Row style={{ fontWeight: "bold", background: "#fafafa" }}>
      <Table.Summary.Cell index={0} colSpan={5}>
        Grand Total
      </Table.Summary.Cell>

      <Table.Summary.Cell index={5}>{inwardQty}</Table.Summary.Cell>
      <Table.Summary.Cell index={6}></Table.Summary.Cell>
      <Table.Summary.Cell index={7}>{inwardAmount}</Table.Summary.Cell>

      <Table.Summary.Cell index={8}></Table.Summary.Cell>
      <Table.Summary.Cell index={9}></Table.Summary.Cell>
      <Table.Summary.Cell index={10}></Table.Summary.Cell>
      <Table.Summary.Cell index={11}></Table.Summary.Cell>

      <Table.Summary.Cell index={12}>{baleQty}</Table.Summary.Cell>
      <Table.Summary.Cell index={13}>{remainingQty}</Table.Summary.Cell>
      <Table.Summary.Cell index={14}>{totalAmount}</Table.Summary.Cell>
    </Table.Summary.Row>
  );
}}
/>

</TabPane>

<TabPane tab='Inward Details' key='inward'>

<Form form={inwardForm} layout='vertical' onFinish={getInwardDetails}>

<Row gutter={16}>

<Col span={6}>
<Form.Item label='Inward No' name='inwardNo'>
<Select placeholder='Select Inward No' showSearch allowClear optionFilterProp='children'>
{inwardNo.map((item:any)=><Option key={item.inwardNo} value={item.inwardNo}>{item.inwardNo}</Option>)}
</Select>
</Form.Item>
</Col>    

<Col span={6}>
<Form.Item label='Inward Variant' name='inwardVariant'>
<Select placeholder='Select Inward Variant' showSearch allowClear optionFilterProp='children'>
{inwardVariant.map((item:any)=><Option key={item.variantId} value={item.variantId}>{item.inwardVariant}</Option>)}
</Select>
</Form.Item>
</Col>

<Col span={6}>
<Form.Item label='Inward Quality' name='inwardQuality'>
<Select placeholder='Select Inward Quality' showSearch allowClear optionFilterProp='children'>
{inwardQuality.map((item:any)=><Option key={item.quality} value={item.quality}>{item.quality}</Option>)}
</Select>
</Form.Item>
</Col>

<Col span={6}>
<Form.Item label='Vendor' name='vendor'>
<Select placeholder='Select Vendor' showSearch allowClear optionFilterProp='children'>
{vendor.map((item:any)=><Option key={item.vendor} value={item.vendor}>{item.vendor}</Option>)}
</Select>
</Form.Item>
</Col>

<Col style={{display:'flex',alignItems:'center',marginTop:30}}>
<Button type='primary' htmlType='submit'>Submit</Button>
</Col>

<Col style={{display:'flex',alignItems:'center',marginTop:30}}>
<Button danger onClick={onResetInward}>Reset</Button>
</Col>

</Row>

</Form>

<Table
columns={InwardColumns}
dataSource={inwardData}
rowKey='key'
pagination={{pageSize:10}}
scroll={{x:'max-content'}}
summary={() => {

    const formatNumber = (value: number) =>
  Number(value.toFixed(3));

  const totalInwardQty = inwardData.reduce(
    (sum, record) =>
      sum +
      record.items.reduce(
        (s, item) => s + Number(item.inwardQty || 0),
        0
      ),
    0
  );

  const totalAmount = inwardData.reduce(
    (sum, record) =>
      sum +
      record.items.reduce(
        (s, item) => s + Number(item.totalAmt || 0),
        0
      ),
    0
  );

  const totalBaleQty = inwardData.reduce(
    (sum, record) =>
      sum +
      record.items.reduce(
        (s, item) => s + Number(item.baleQty || 0),
        0
      ),
    0
  );

  const totalRemainingQty = inwardData.reduce(
    (sum, record) =>
      sum +
      record.items.reduce(
        (s, item) => s + Number(item.remainingQty || 0),
        0
      ),
    0
  );

  const totalRemainingAmount = inwardData.reduce(
    (sum, record) =>
      sum +
      record.items.reduce(
        (s, item) => s + Number(item.remainingAmt || 0),
        0
      ),
    0
  );

  return (
<Table.Summary.Row>
    <Table.Summary.Cell index={0} colSpan={6}>
        Grand Total
    </Table.Summary.Cell>

    <Table.Summary.Cell index={6}>
        {formatNumber(totalInwardQty)}
    </Table.Summary.Cell>

    <Table.Summary.Cell index={7}></Table.Summary.Cell>

    <Table.Summary.Cell index={8}>
        {formatNumber(totalAmount)}
    </Table.Summary.Cell>

    <Table.Summary.Cell index={9}>
        {formatNumber(totalRemainingQty)}
    </Table.Summary.Cell>

    <Table.Summary.Cell index={10}>
        {formatNumber(totalRemainingAmount)}
    </Table.Summary.Cell>
</Table.Summary.Row>
  );
}}
/>

</TabPane>

</Tabs>

</Card>

</div>
)

}

export default BaleReport